import { clsx } from '@alexis/helpers/clsx';
import { isEnvironmentProduction } from '@alexis/helpers/environment';
import { translateText } from '@alexis/helpers/translation';
import React from 'react';
import { useSelector } from 'react-redux';
import Turnstile, { useTurnstile } from 'react-turnstile';

import { CF_TURNSTILE_SITEKEY_STAGING, CF_TURNSTILE_SITEKEY_PRODUCTION } from '@constants/general';

import {
  getCurrentSiteState,
  getIsRtlState,
  getLocaleState,
  getTranslationsState,
} from '@redux/selectors';

import styles from './TurnstileWidget.module.scss';

interface TurnstileWidgetProps {
  onVerify: () => void;
}

const TurnstileWidget: React.FC<TurnstileWidgetProps> = ({ onVerify }) => {
  const isRtl = useSelector(getIsRtlState);
  const locale = useSelector(getLocaleState);
  const translations = useSelector(getTranslationsState);
  const { host } = useSelector(getCurrentSiteState);

  const turnstile = useTurnstile();

  const hostname = window.location.hostname;
  const sitekey = isEnvironmentProduction(hostname)
    ? CF_TURNSTILE_SITEKEY_PRODUCTION
    : CF_TURNSTILE_SITEKEY_STAGING;

  return (
    <div className={clsx(styles.container, isRtl && styles.rtl)}>
      <div className={styles.widget}>
        <div>
          <div className={styles.domainHeader}>{host}</div>

          <div className={styles.subHeader}>{translations.bot_challenge_title}</div>
        </div>

        <Turnstile sitekey={sitekey} onExpire={() => turnstile.reset()} onVerify={onVerify} />
        <div className={styles.subHeader}>
          {translateText(translations.bot_challenge_desc, locale, host)}
        </div>
      </div>
    </div>
  );
};

export default TurnstileWidget;
